import { render, staticRenderFns } from "./NgoaiNguList.vue?vue&type=template&id=4c679539&"
import script from "./NgoaiNguList.vue?vue&type=script&lang=js&"
export * from "./NgoaiNguList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports